/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackers (patients) to display or load trackers */


(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackerlist', {
      restrict: 'E',
      bindings: {
        trackers: '<?'
      },
      template: `
        <div class="row" ng-show="vm.trackers.length == 0">
          <div class="alert alert-info">
            <i class="fa fa-info-circle fa-2x"></i> Sie haben noch keine Meßwert-Tracker definiert.
          </div>
        </div>
        <table class="table table-striped" ng-show="vm.trackers.length > 0">
          <thead>
          <tr>
            <th>Bezeichnung</th>
            <th>Inhalt</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="tracker in vm.trackers">
            <td>{{tracker.name}}</td>
            <td>
                <ul>
                    <li ng-repeat="t in tracker.def">{{t.label}}</li>
                </ul>
            </td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editTracker(tracker)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeTracker(tracker)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Tracker', 'TrackerHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Tracker, TrackerHelper, vertxEventBusService) {
          let vm = this;
          vm.editTracker = TrackerHelper.editTracker;
          vm.removeTracker = removeTracker;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.trackers)) {
              vm.trackers = Tracker.$search();
            }
          }; // $onInit()
          
          
          function removeTracker(tracker) {
            tracker.active = false;
            tracker.$save();
          }
          
          vertxEventBusService.on('trackers.update', function (message) {
            $log.debug('debug: tracker update received: ', message);
            vm.trackers.$refresh().$then(function () {
              $log.debug('debug: trackerlist refreshed trackers');
            }, function (error) {
              $log.debug('debug: trackerlist refresh trackers failed: ', error);
            });
          });
          
          
          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());
